import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { addStore } from 'client/shared/react-util';

import FieldFactory from '../field-factory';

@inject('songsStore', 'formStore', 'albumsStore')
@observer
class SongForm extends Component {
	render () {
		const { songsStore, formStore, albumsStore, song = {} } = this.props;
		const FieldWithStore = addStore(FieldFactory, { store: songsStore, formStore });

		return (
			<div className='grid-container'>
				<div className="grid-x">
					<div className="cell">
						<h4>Song Info { song.title }</h4>
						<FieldWithStore
							dataId={ song.id }
							fieldKey="song.artistID"
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-12 large-9">
						<FieldWithStore
							dataId={ song.id }
							fieldKey="song.title"
						/>
					</div>
					<div className="cell small-12 large-3">
						<FieldWithStore
							dataId={ song.id }
							fieldKey="song.explicit"
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						<FieldWithStore
							dataId={ song.id }
							fieldKey="song.albumIDs"
							optionsStore={ albumsStore }
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						<FieldWithStore
							dataId={ song.id }
							fieldKey="song.embedCode"
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default SongForm;
